export const generateApiUrl = (url: string): string => {
	const baseUrl = process.env.REACT_APP_ORDER_API;
	return `${baseUrl}${url}`;
};
